import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supervisor-queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.scss']
})
export class SupervisorQueueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
